// @flow
import React, { useContext } from 'react';
import { Grid } from 'semantic-ui-react';

import { CNBCRibbonContainer } from '../common/sgcnbc/CNBCRibbonContainer';
import {
  FieldArrayGridConfigItemContext,
  FieldArrayStyledGridRow,
} from '../../formik-utils/FieldArrayGrid';
import { FieldArrayErrorMessagesContainer } from '../../formik-utils/FieldArrayErrorMessagesContainer';
import { CREDITS_AND_BURSTS_CONFIG_ARRAY_CONFIG } from '../../configuration/credits-and-bursts';
import { IS_ROW_FROZEN, IS_ROW_OPENED_FOR_EDITING } from '../../constants';
import { useIsSGCNBCApplicable } from '../../custom-hooks/useIsSGCNBCApplicable';

import { YearContainer } from './YearContainer';
import { CreditsAmountContainer } from './CreditsAmountContainer';
import { BurstsAmountContainer } from './BurstsAmountContainer';
import { UpdateButtonContainer } from './UpdateButtonContainer';
import { DeleteButtonContainer } from './DeleteButtonContainer';
import { getIfCNBCRowIsAdmin, getIfCNBCRowIsSG } from './utils';

export const CreditAndBurstsConfigurationItem = ({ calendarYears, cnbcInputs, readOnlyMode }) => {
  const { rowValues } = useContext(FieldArrayGridConfigItemContext);

  const shouldShowErrorMessagesAtTheBottom = !rowValues[IS_ROW_OPENED_FOR_EDITING] || readOnlyMode;
  const isSGCNBCApplicable = useIsSGCNBCApplicable();

  return (
    <>
      <FieldArrayStyledGridRow>
        {/* Requires 3 because of the extra ribbon column width */}
        <Grid.Column width={3}>
          {/* Only show SG/Ad/NA tag after row is saved (frozen).
              For WIP rows, the tag is not meaningful since is_admin_edited is set by backend on save. */}
          {isSGCNBCApplicable && rowValues[IS_ROW_FROZEN] && (
            <CNBCRibbonContainer
              isAddedByAdmin={getIfCNBCRowIsAdmin(rowValues)}
              isSystemGenerated={getIfCNBCRowIsSG(rowValues)}
            />
          )}
          <YearContainer calendarYears={calendarYears} cnbcInputs={cnbcInputs} />
        </Grid.Column>
        <Grid.Column width={2}>
          <CreditsAmountContainer />
        </Grid.Column>
        <Grid.Column width={2}>
          <BurstsAmountContainer />
        </Grid.Column>
        <Grid.Column width={1}>
          <UpdateButtonContainer />
        </Grid.Column>
        <Grid.Column width={1}>
          <DeleteButtonContainer />
        </Grid.Column>
      </FieldArrayStyledGridRow>

      {shouldShowErrorMessagesAtTheBottom && (
        <FieldArrayErrorMessagesContainer
          arrayColumnConfig={CREDITS_AND_BURSTS_CONFIG_ARRAY_CONFIG}
        />
      )}
    </>
  );
};
